export const invalidChars = ['e', 'E', '+', '-', '.'];
